import { combineReducers } from 'redux';

import {
  transferCreditRequest,
  transferCreditSuccess,
  transferCreditFail,
} from '../actions';
import { AdjustCreditResponse, CreditAction } from '../types';

const data = (state: AdjustCreditResponse | null = null, action: CreditAction) => {
  switch (action.type) {
    case transferCreditFail.type:
    case transferCreditRequest.type:
      return null;

    case transferCreditSuccess.type:
      return action.payload;

    default:
      return state;
  }
};

const loading = (state = false, action: CreditAction) => {
  switch (action.type) {
    case transferCreditRequest.type:
      return true;

    case transferCreditFail.type:
    case transferCreditSuccess.type:
      return false;

    default:
      return state;
  }
};

const error = (state = false, action: CreditAction) => {
  switch (action.type) {
    case transferCreditFail.type:
      return true;

    case transferCreditRequest.type:
    case transferCreditSuccess.type:
      return false;

    default:
      return state;
  }
};

export default combineReducers({
  data,
  loading,
  error,
});
